import { IMPORT_CLOSE_IMPORT_MAPPING } from './constants';
export function closeImportMapping() {
  return {
    type: IMPORT_CLOSE_IMPORT_MAPPING,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case IMPORT_CLOSE_IMPORT_MAPPING:
      return {
        ...state,
        isOpenMappingPage: false,
      };

    default:
      return state;
  }
}
